import { RefObject, useEffect } from 'react'
import { useResizeObserver } from 'usehooks-ts'
import { useLayoutContext } from '@/context/LayoutContext'

export const useCalculateHeaderHeight = (headerRef: RefObject<HTMLDivElement | null>) => {
  const { setHeaderHeight } = useLayoutContext()
  const { height: headerHeight = 0 } = useResizeObserver({
    ref: headerRef as RefObject<HTMLElement>,
    box: 'border-box',
  })

  useEffect(() => {
    if (headerHeight > 0) {
      setHeaderHeight(headerHeight)
    }
  }, [headerHeight, setHeaderHeight])
}
